<template>
  <div class="select_dialog_embed">
    <div class="channel_list_embed_msg"
         :class="{'channelDetailWidth': showType === 'channelDetail',
         'afterSaleWidth': showType === 'openAfterSale' || showType === 'closeAfterSale'}">
      <div class="select_dialog_embed_box">
        <!--弹出框头部-->
        <div class="select_dialog_embed_box_top">
          <p>{{title}}</p>
        </div>

        <!--弹出框信息-->
        <!--渠道详情-->
        <div v-if="showType === 'channelDetail'" class="select_dialog_embed_box_content">
          <!--顶部信息-->
          <div class="channel_detail_top">
            <div class="channel_detail_top_left">
              <div><label>供应商编号：</label><span>{{channelDetail.SupplierCode}}</span></div>
              <div><label>渠道编号：</label><span>{{channelDetail.StoreroomCode}}</span></div>
              <!--<div><label>渠道编号：</label><span>{{channelDetail.SupplierCode}}_{{channelDetail.StoreroomCode}}</span></div>-->
              <!--<div><label>发货地址：</label><span>{{channelDetail.SendProvinceName}}{{channelDetail.SendCityName}}{{channelDetail.SendAreaName}}</span></div>-->
              <div><label>联系电话：</label><span>{{channelDetail.Tel}}</span></div>
              <!--<div><label>QQ号：</label><span>{{channelDetail.QQ}}</span></div>-->
              <div><label>截单时间：</label><span>{{channelDetail.StopJiaoDanString}}</span></div>
              <div v-if="channelDetail.PromiseSendRate"><label>承诺配货率：</label><span>{{channelDetail.PromiseSendRate}}%</span></div>
              <div v-if="!channelDetail.PromiseSendRate"><label>承诺配货率：</label><span></span></div>
              <!--<div><label>免费退货比例：</label><span>{{channelDetail.FreeMaxRefundRate}}%</span></div>-->
              <div><label>？允许售后：</label><span>{{channelDetail.IsReOrder | aftersale}}</span></div>
              <!--<div><label>超比例退货费用：</label><span>￥{{channelDetail.RefundFee}}</span></div>-->
              <!--<div><label>库存更新时间：</label><span>{{channelDetail.StockUpdateTime}}</span></div>-->
            </div>
            <div class="channel_detail_top_right">
              <div><label>供应商名称：</label><span>{{channelDetail.SupplierName}}</span></div>
              <div><label>渠道名称：</label><span>{{channelDetail.StoreroomName}}</span></div>
              <div><label>？渠道包邮：</label><span>{{channelDetail.IsFreeShip | isfreeship}}</span></div>
              <!--<div><label>微信号：</label><span>{{channelDetail.Wetchart}}</span></div>-->
              <div><label>邮箱：</label><span>{{channelDetail.Email}}</span></div>
              <!--<div><label>渠道类型：</label><span>{{channelDetail.StoreroomType | channeltype}}</span></div>-->
              <div v-if="channelDetail.RealSendRate"><label>实际配货率：</label><span>{{channelDetail.RealSendRate}}%</span></div>
              <div v-if="!channelDetail.RealSendRate"><label>实际配货率：</label><span></span></div>
              <!--<div><label>超比例退货费用：</label><span>￥{{channelDetail.RefundRate}}</span></div>-->
              <!--<div><label>免费退货比例：</label><span>{{channelDetail.FreeRefundRate}}%</span></div>-->
              <div><label>发货日期：</label><span>{{channelDetail.SendWeekday}}</span></div>
            </div>
            <!--<div><label>发货日期：</label><span>{{channelDetail.SendWeekday}}</span></div>-->
          </div>
          <div class="mb10"><label>库存更新时间：</label><span>{{channelDetail.StockUpdateTime | time}}</span></div>
          <!--底部信息-->
          <div class="channel_detail_bottom">
            <div><label>不发货日期：</label><textarea title="不发货日期" v-model="channelDetail.NoSendDay" disabled></textarea></div>
            <div><label>退货说明：</label><textarea title="退货说明" v-model="channelDetail.RefundRemark" disabled></textarea></div>
            <div><label>退货地址：</label><textarea title="退货地址" v-model="channelDetail.RefundAddress" disabled></textarea></div>
            <div><label>备注：</label><textarea title="备注" v-model="channelDetail.Remark" disabled></textarea></div>
          </div>
        </div>

        <!--开启自收-->
        <div v-if="showType === 'openAfterSale'" class="select_dialog_embed_box_content">
          <p class="text_center mt20 mb20">是否开启所选渠道售后自收？</p>
        </div>

        <!--关闭自收-->
        <div v-if="showType === 'closeAfterSale'" class="select_dialog_embed_box_content">
          <p class="text_center mt20 mb20">是否关闭所选渠道自收？</p>
        </div>


        <!--弹出框底部-->
        <div class="select_dialog_embed_box_bottom">
          <button v-if="showType === 'openAfterSale' || showType === 'closeAfterSale'" class="btn_normal" @click="submitBtn()">确定</button>
          <button class="btn_cancel" @click="cancelBtn()">关闭</button>
        </div>
      </div>
    </div>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :is-suc="isSuc"
                :txt="txtMsg" @closebtn="closeMsgDialog"></msg-dialog>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>

  </div>
</template>

<script type="es6">
  import MsgDialog from '../../public-component/msg-dialog';
  import LoadingDialog from '../../public-component/loading-dialog';

    export default {
        name: 'channel-list-embed-msg',
      /**
       *  title：  头部名
       *  showType: channelDetail=查看渠道详情
       *  channelMsg: 渠道信息
       * */
      props: ['title', 'showType', 'channelMsg'],
      components: {MsgDialog, LoadingDialog},
      data() {
        return {
          channelDetail: '', // 渠道详情
          isLoading: false, // 是否显示加载框
          loadingType: 'NOP', // 加载页面类型
          isMsg: false, // 信息框显示
          isSuc: false, // 是否成功
          txtMsg: '信息框内容', // 信息框内容
        }
      },
      methods: {
        // 查看渠道详情
        getStoreroomModelById() {
          this.$axios.get(this.Global.getStoreroomModelById(this.channelMsg.Id), null).then((res) => {
            console.log(res);
            this.channelDetail = res.data.resData;
          });
        },

        // 是否开启售后自收
        openOrCloseAfteSale(type) {
          this.loadingType = 'options';
          this.$axios.post(this.Global.openOrCloseAfteSale(this.channelMsg.SupplierCode, this.channelMsg.StoreroomCode, type), null).then((res) => {
            let timer;
            const self = this;
            timer = setTimeout(function () {
              clearTimeout(timer);
              self.isLoading = false;
              if (!res.data.errorMsg.length) {
                // this.cancelBtn(true);
                self.isMsg = true;
                self.isSuc = true;
                self.txtMsg = '操作成功';
              } else {
                self.failFun(res.data.errorMsg);
              }
            }, 500);
          });
        },

        // 提交按钮
        submitBtn() {
          this.isLoading = true;
          this.loadingType === 'options';
          if (this.showType === 'openAfterSale') {
            this.openOrCloseAfteSale(true);
          } else if (this.showType === 'closeAfterSale') {
            this.openOrCloseAfteSale(false);
          }
        },

        // 取消按钮
        cancelBtn(type) {
          this.$emit('cancelbtn', {isShow: false, showType: this.showType, handleType: type});
        },

        // 失败执行的方法
        failFun(txt) {
          this.isLoading = false;
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = txt;
          let time = 3;
          const self = this;
          const timer = setInterval(function () {
            time = --time;
            if (time < 1) {
              self.isMsg = false;
              clearInterval(timer);
            }
          }, 1000);
        },

        // 接收提示框传送的数据
        closeMsgDialog(e) {
          this.isMsg = e;
          if (this.isSuc) {
            this.cancelBtn(true);
          }
        }
      },
      created() {
        if (this.showType === 'channelDetail') {
          this.getStoreroomModelById();
        }
      }
    }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .select_dialog_embed {
    .channel_list_embed_msg {
      &.channelDetailWidth {
        width: 80%;
        min-width: 580px;
        max-height: 100%;
      }

      &.afterSaleWidth {
        width: 460px;
      }


      .select_dialog_embed_box {
        width: 100%;

        .select_dialog_embed_box_content {
          width: 90%;
          padding: 0 5%;

          label {
            font-weight: bolder;
            display: inline-block;
            width: 120px;
            text-align: right;
          }

          .channel_detail_top {
            width: 100%;
            max-height: 234px;
            margin-bottom: 10px;

            .channel_detail_top_left {
              width: 48%;
            }

            .channel_detail_top_right {
              width: 52%;
            }

           .channel_detail_top_left, .channel_detail_top_right {
             display: inline-block;
             float: left;
             margin-bottom: 5px;

             div {
               margin-top: 10px;
             }
           }
          }

          .channel_detail_bottom {
            div {
              margin-bottom: 5px;
            }

            label {
              height: 65px;
              line-height: 65px;
              float: left;
            }

            textarea {
              width: 75%;
              height: 45px;
              padding: 10px;
              resize: none;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/channel-list-embed-msg.vue